import { createSlice } from "@reduxjs/toolkit";

const GlobalStatusSlice = createSlice({
  name: "GlobalStatus",
  initialState: {
    data: {
      IsLogedIn: false,
      Email: "",
    },
  },
  reducers: {
    GlobalStatusAction(state, action) {
      for (const [key, value] of Object.entries(action.payload)) {
        state.data[key] = value;
      }
    },
  },
});

export const { GlobalStatusAction } = GlobalStatusSlice.actions;
export default GlobalStatusSlice.reducer;
